import { findCountryIconByLocale } from '@/i18n/helpers'
import Model from '@models/Model'

export default class Locale extends Model {
  get primaryTag () {
    return this.$model.locale.substr(0, 2)
  }

  get icon () {
    return findCountryIconByLocale(this.primaryTag)
  }

  getSchema () {
    return {
      'locale': {
        type: String
      }
    }
  }

  toString () {
    return this.$model.locale
  }
}



// WEBPACK FOOTER //
// ./src/models/Locale/model.js